import { AfterViewInit, Directive, ElementRef, Host, Input, OnDestroy, Optional } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { Subscription, distinctUntilChanged } from 'rxjs';

@Directive({
  selector: '[docBootstrapInput]',
  standalone: true,
})
export class BootstrapInputDirective implements AfterViewInit, OnDestroy {
  @Input('docBootstrapInput') formControlName: string;
  subscription: Subscription;
  constructor(private el: ElementRef, @Optional() @Host() private controlContainer: ControlContainer) { }

  ngAfterViewInit() {
    this.updateValidationClass();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private updateValidationClass() {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const control = this.controlContainer.control.get(this.formControlName);

    this.subscription = control?.statusChanges.pipe(distinctUntilChanged()).subscribe({
      next: (status) => {
        // console.log({ status });
        if ((control.touched || control.dirty)) {
          if (control.valid) {
            inputElement.classList.add('is-valid');
            inputElement.classList.remove('is-invalid');
          } else if (control.invalid) {
            inputElement.classList.add('is-invalid');
            inputElement.classList.remove('is-valid');
          } else {
            inputElement.classList.remove('is-valid', 'is-invalid');
          }
        } else {
          inputElement.classList.remove('is-valid', 'is-invalid');
        }
      }
    })

  }
}
